import React, { useRef } from "react";
import emailjs from "emailjs-com";
import productImage from "./WhatsApp Image 2025-12-22 at 11.27.57 PM (1) (1).png";
import "./App.css";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_kyp8cjh",  
        "template_4t8r84a",  
        form.current,
        "e4cj_ZrXDDyLp2e0C"    
      )
      .then(
        (result) => {
          alert("Message sent successfully!");
          form.current.reset();
        },
        (error) => {
          alert("Failed to send message. Try again!");
          console.log(error.text);
        }
      );
  };

  return (
    <>
        <head>
        <title>OM AGRO FOODS | Premium Kesar Mango Pulp Manufacturer & Supplier</title>

        <meta
          name="description"
          content="OM AGRO FOODS offers premium quality Kesar Mango Pulp made from handpicked mangoes. Ideal for aamras, ice creams, desserts, beverages, and bulk supply."
        />

        <meta
          name="keywords"
          content="om agro foods, Kesar Mango Pulp, Contact of om agro foods, Contact for buy mango, Contact for buy mango pulp, Contact number of om agro foods, Contact natural mango pulp Manufacturer, Contact om agro foods gir, Mango Pulp Manufacturer, Mango Pulp Supplier, OM AGRO FOODS, om agro foods, natural mango pulp, mango pulp,  pulp, Aamras Pulp, Bulk Mango Pulp"
        />

        <link rel="canonical" href="https://omagrofoods.vercel.app/" />

        <link rel="icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" sizes="48x48" />
        <link rel="icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" sizes="96x96" />
        <link rel="icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" sizes="192x192" />
        <link rel="shortcut icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" />
        <link rel="apple-touch-icon" type="image/png" href="%PUBLIC_URL%/site-logo-omagrofood.png" />
        <meta property="og:title" content="OM AGRO FOODS | Premium Kesar Mango Pulp" />
        <meta
          property="og:description"
          content="Premium quality Kesar Mango Pulp with rich taste, aroma, and natural sweetness. Available for retail and bulk orders."
        />
        <meta property="og:image" content={productImage} />
        <meta property="og:url" content="https://omagrofoods.vercel.app/" />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="OM AGRO FOODS | Premium Mango Pulp" />
        <meta
          name="twitter:description"
          content="Premium Kesar Mango Pulp supplier for homes, hotels, and food industries."
        />
        <meta name="twitter:image" content={productImage} />
      </head>
    <div className="contact-page">
      <div className="contact-overlay">
        <div className="contact-container">
          <h1>Contact Us</h1>
          <p>
            Get in touch with OM AGRO FOOD for inquiries and
            support. We’d love to hear from you.
          </p>

          <form ref={form} onSubmit={sendEmail} className="contact-form">
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                required
              />
            </div>

            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                required
              />
            </div>

            <div className="form-group">
              <input
                type="text"
                name="subject"
                placeholder="Subject"
              />
            </div>

            <div className="form-group">
              <textarea
                name="message"
                placeholder="Your Message"
                rows="4"
                required
              ></textarea>
            </div>

            <button type="submit" className="contact-btn">
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>
    </>
  );
};

export default Contact;
